import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { VisuallyHidden } from '@andes/common';
import useSrLabel from '@andes/common/build/hooks/useSrLabel';
import { useId } from '@andes/context';
const namespace = 'andes-progress-indicator-circular';
const circleNamespace = "".concat(namespace, "__circle");
var _circle;
const Indeterminate = _ref => {
  let {
    labelId,
    srLabel
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "aria-label": srLabel,
    "aria-labelledby": srLabel ? undefined : labelId,
    role: "progressbar"
  }, void 0, /*#__PURE__*/_jsx("svg", {
    className: "".concat(namespace, "__svg"),
    "aria-hidden": "true",
    viewBox: "0 0 50 50"
  }, void 0, _circle || (_circle = /*#__PURE__*/_jsx("circle", {
    className: circleNamespace,
    cx: "50%",
    cy: "50%",
    r: "20",
    fill: "none"
  }))));
};
var Indeterminate$1 = Indeterminate;
const Determinate = _ref => {
  let {
    continuous = false,
    id,
    labelId,
    srLabel,
    value = 0
  } = _ref;
  const circunference = 124;
  const circlePercentage = circunference * value / 100;
  const circleClassnames = classNames(circleNamespace, {
    ["".concat(circleNamespace, "--continuous")]: continuous
  });
  return /*#__PURE__*/_jsx("div", {
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-label": srLabel,
    "aria-labelledby": srLabel ? undefined : labelId
  }, void 0, /*#__PURE__*/_jsx("svg", {
    className: "".concat(namespace, "__svg"),
    "aria-hidden": "true",
    viewBox: "0 0 50 50"
  }, void 0, /*#__PURE__*/_jsx("circle", {
    className: "".concat(circleNamespace, "-bg"),
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none"
  }), /*#__PURE__*/_jsx("circle", {
    className: circleClassnames,
    strokeDasharray: circunference,
    strokeDashoffset: "".concat(circunference - Math.min(circlePercentage, circunference)),
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none"
  }, id)));
};
var Determinate$1 = Determinate;
const ProgressIndicatorCircular = /*#__PURE__*/function () {
  const ProgressIndicatorCircular = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      id,
      size = 'medium',
      color = 'blue',
      type = 'indeterminate',
      className,
      label,
      value,
      children,
      continuous = false,
      srLabel,
      srAnnouncement,
      'aria-label': ariaLabel,
      notificationsLabel: _willdeprecate$notificationsLabel,
      modifier
    } = props;
    const componentId = useId(id);
    const labelId = label && "".concat(id, "__label");
    const srLabelVisibility = useSrLabel();
    const getSubcomponent = () => {
      const commonProps = {
        srLabel: srLabel || ariaLabel,
        labelId
      };
      if (type === 'determinate') {
        const determinateProps = _objectSpread({
          value,
          continuous,
          id: componentId
        }, commonProps);
        return /*#__PURE__*/React.createElement(Determinate$1, determinateProps);
      }
      return /*#__PURE__*/React.createElement(Indeterminate$1, commonProps);
    };
    const progressIndicatorClassnames = classNames(namespace, className, {
      ["".concat(namespace, "--").concat(type)]: type,
      ["".concat(namespace, "--").concat(size)]: size,
      ["".concat(namespace, "--").concat(color)]: color,
      ["".concat(namespace, "--").concat(modifier)]: modifier
    });
    const computedSrAnnouncement = srAnnouncement || _willdeprecate$notificationsLabel;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: progressIndicatorClassnames
    }, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__container")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__progress")
    }, void 0, computedSrAnnouncement && /*#__PURE__*/_jsx(VisuallyHidden, {
      role: "status",
      "aria-live": "polite"
    }, void 0, srLabelVisibility && computedSrAnnouncement), getSubcomponent(), children && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespace, "__content")
    }, void 0, children)), label && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "__label"),
      id: labelId
    }, void 0, label)));
  });
  ProgressIndicatorCircular.displayName = 'ProgressIndicatorCircular';
  return ProgressIndicatorCircular;
}();
var ProgressIndicatorCircular$1 = ProgressIndicatorCircular;
export { ProgressIndicatorCircular$1 as ProgressIndicatorCircular, ProgressIndicatorCircular$1 as default };
